// extracted by mini-css-extract-plugin
export default {"page":"styles_page__Yop3N","pageEnter":"styles_pageEnter__ziMBK"};